import script from "./UserRegistComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRegistComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserRegistComponent.vue?vue&type=style&index=0&id=3fb9d842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb9d842"]])

export default __exports__